import React from 'react'
import useI18n from '../../../i18n/useI18n'
import { formatNumber } from '../utils'

const TopListCard = ({ title, subtitle, items = [], loading }) => {
  const { t } = useI18n()

  return (
    <div className="card dashboard-card">
      <div className="header">
        <h2><strong>{title}</strong></h2>
        {subtitle && <small>{subtitle}</small>}
      </div>
      <div className="body">
        {loading && !items.length && (
          <div className="skeleton-list">
            {[...Array(4)].map((_, index) => (
              <div className="skeleton-line" key={index}></div>
            ))}
          </div>
        )}
        {!loading && !items.length && (
          <div className="empty-state">{t('DASHBOARD_CARD_EMPTY_STATE')}</div>
        )}
        {items.length > 0 && (
          <ul className="top-list">
            {items.map((item) => (
              <li key={item.id || item.name} className="top-list-item">
                <div>
                  <p className="top-list-title">{item.name}</p>
                  {item.city && (
                    <span className="top-list-subtitle">{item.city}</span>
                  )}
                </div>
                <span className="top-list-value">{formatNumber(item.applicationsCount)}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}

export default TopListCard

